import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppRoutes, createQueryClient } from './App';
import './index.css';

async function start(): Promise<void> {
  // `VITE_MOCK=1 pnpm --filter web dev` serves every API call from in-browser mocks.
  if (import.meta.env.VITE_MOCK === '1') {
    const { startMocks } = await import('./mocks/browser');
    await startMocks();
  }
  const queryClient = createQueryClient();
  const root = document.getElementById('root');
  if (!root) throw new Error('root element missing');
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
